// Copyright ©️ 2026 eVolve MEP, LLC

import { ColorField } from './ColorField';

type StrokeColorFieldProps = {
  colorId: string;
  labelId: string;
  opacityId: string;
  colorLabel: string;
  opacityLabel: string;
  colorDisplayValue: string;
  opacityValue: string;
};

export const StrokeColorField = (props: StrokeColorFieldProps) => <ColorField {...props} />;
